export function inDevEnvironment() {
  return (
    ['127.0.0.1', 'localhost'].includes(window.location.hostname)
    || window.location.hostname.includes('playpauseit.com')
    || window.location.hostname === 'api-test.playposit.com'
    || window.location.hostname === 'api-dev-16.playposit.com'
  );
}